import React, { useEffect, useState } from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import './DashboardStyle.css'

type ChartTabsProps = {
  tabs: TabProps[]
  defaultActiveKey: string
}

type TabProps = {
  content: React.ReactElement
  tabName: string
  eventKey: string
}

function ChartTabs({
  tabs,
  defaultActiveKey,
}: ChartTabsProps): React.ReactElement {
  const [key, setKey] = useState(defaultActiveKey)

  useEffect(() => {
    window.dispatchEvent(new Event('resize'))
  }, [key])

  return (
    <Row className="text-center mb-2 chart-tab">
      <Tab.Container activeKey={key} onSelect={(k) => k && setKey(k)}>
        <Col md={12}>
          <Tab.Content className="">
            {tabs.map(({ content, eventKey, tabName }) => (
              <Tab.Pane eventKey={eventKey} key={`${tabName}-${eventKey}`}>
                {content}
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Col>
        <Col md={12} className="p-0">
          <Nav variant="pills" className="chart-tab">
            {tabs.map(({ eventKey, tabName }) => (
              <Nav.Item key={`${tabName}-${eventKey}`} className="">
                <Nav.Link eventKey={eventKey}>{tabName}</Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Col>
      </Tab.Container>
    </Row>
  )
}

export default ChartTabs
